export const urlTitle = {
  entertainment: "S35",
  "life-lifestyle": "S33",
  tech: "S34",
  automotive: "S38",
  "sports-outdoors": "S40",
  travel: "S36",
  "beauty-fashion": "S37",
  "home-garden": "S39",
  "baby-kids": "S87",
  pets: "S86",
  tariffs: "S88",
  "finance-communication": "S89",
  "film-tv": "S15",
  toys: "S16",
  "gift-ideas": "S11",
  "food-gourmet": "S12",
  drinks: "S13",
  cars: "S19",
  "car-accessories": "S20",
  fitness: "S30",
  outdoor: "S31",
  gadgets: "S24",
  "tv-home-entertainment": "S25",
  "audio-hifi": "S26",
  "consoles-video-games": "S14",
  "tourist-destinations": "S17",
  wellness: "S28",
  beauty: "S27",
  fashion: "S29",
  health: "S32",
  garden: "S21",
  household: "S22",
  kitchen: "S23",
  "console-videogames": "S63",
  "sport-gear": "S64",
  devices: "S65",
  computer: "S66",
  tv: "S67",
  software: "S68",
  sports: "S69",
  outdoors: "S70",
  "baby-and-kid-toys": "S71",
  clothing: "S72",
  childcare: "S73",
  hotels: "S74",
  transportation: "S75",
  hygiene: "S76",
  dog: "S77",
  cat: "S78",
  medicine: "S79",
  "other-pets": "S80",
  insurance: "S81",
  electricity: "S82",
  loan: "S83",
  "internet-providers": "S84",
  "mobile-plans": "S85"
};
